import { User } from "../user/user";

export class ConnectedDevice {

  id: string | undefined;
  appVersion: string | undefined;
  lastSeenDateTime: string | undefined;
  platform: string | undefined;
  model: string | undefined;
  name: string | undefined;
  bugfenderDeviceUrl: string | undefined;
  user: User | undefined;
  permissions: any | undefined;
  androidSdk: string | undefined;
  createdDateTime: string | undefined;
  osVersion: string | undefined;
  language: string | undefined;
  locale: string | undefined;
  // uploads: any;
  updateState: string | undefined;
  debugDeviceUrl: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.appVersion = payload.appVersion;
      this.lastSeenDateTime = payload.lastSeenDateTime;
      this.platform = payload.platform;
      this.model = payload.model;
      this.name = payload.name;
      this.bugfenderDeviceUrl = payload.bugfenderDeviceUrl;
      this.osVersion = payload.osVersion;
      if(payload.user){
        this.user = new User(payload.user);
      }
      this.permissions = payload.permissions;
      this.androidSdk = payload.androidSdk;
      this.createdDateTime = payload.createdDateTime;
      // this.uploads = payload.uploads;
      this.updateState = payload.updateState;
      this.language = payload.language;
      this.locale = payload.locale;
      this.debugDeviceUrl = payload.debugDeviceUrl;
    }
  }

  /**
   * creates roles from a result
   * @param result Array of any
   * @returns Array of ApiKey
   */
   static createMobileDevices(result: Array<any>): ConnectedDevice[] {
    const mobileDevices = new Array<ConnectedDevice>();
    if (result) {
      result.map((event) => {
        mobileDevices.push(new ConnectedDevice(event));
      });
    }
    return mobileDevices;
  }
}


export class MobileDeviceUpload {
  id: string | undefined;
  mobileDevice: ConnectedDevice | undefined;
  type: string | undefined;
  uri: [string] | undefined;;
  state: string | undefined;
  startDateTime: boolean | undefined;
  retryCount: number | undefined;
  retryEarliestBeginDateTime: string | undefined;
  latestFailedDateTime: string | undefined;
  lastHttpStatusCode: number | undefined;
  lastErrorCode: string | undefined;
  expiryDateTime: string | undefined;
  fileOwnerIds: [string] | undefined;
  successDateTime: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      if(payload.mobileDevice){
        this.mobileDevice = new ConnectedDevice(payload.mobileDevice);
      }
      this.type = payload.type;
      this.uri = payload.uri;
      this.state = payload.state;
      this.startDateTime = payload.startDateTime;
      this.retryCount = payload.retryCount;
      this.retryEarliestBeginDateTime = payload.retryEarliestBeginDateTime;
      this.latestFailedDateTime = payload.latestFailedDateTime;
      this.lastHttpStatusCode = payload.lastHttpStatusCode;
      this.lastErrorCode = payload.lastErrorCode;
      this.expiryDateTime = payload.expiryDateTime;
      this.fileOwnerIds = payload.fileOwnerIds;
      this.successDateTime = payload.successDateTime;
    }
  }
  
}
